import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
//import { AutofocusDirective } from '../directives/autofocus.directive';
import { AccessRightDirective } from '../directives/accessrights.directive';
//import { AccessRight2Directive } from '../directives/accessright.directive';
import { NumbersOnly } from '../directives/numbersonly.directive';
import { FormatJsonPipe } from '../../common/pipes/formatJson.pipe';
import { FileTypePipe } from '../../common/pipes/filetype.pipe';
import { PanelBarModule, LayoutModule } from '@progress/kendo-angular-layout';
import { MatCardModule } from '@angular/material/card';

@NgModule({
    imports: [MatButtonModule, MatProgressSpinnerModule, MatProgressBarModule, MatSlideToggleModule, MatExpansionModule, MatIconModule, MatCardModule, CommonModule, FlexLayoutModule, FormsModule,ReactiveFormsModule, ExcelExportModule, DropDownsModule, DialogModule, PopupModule, PanelBarModule, LayoutModule],
    declarations: [AccessRightDirective, NumbersOnly, FormatJsonPipe, FileTypePipe],    //AutofocusDirective, AccessRight2Directive
    exports: [MatButtonModule, MatProgressSpinnerModule, MatProgressBarModule, MatSlideToggleModule, MatExpansionModule, MatIconModule, MatCardModule, CommonModule, FlexLayoutModule, FormsModule,ReactiveFormsModule, ExcelExportModule, DropDownsModule, DialogModule, PopupModule, PanelBarModule, LayoutModule,  AccessRightDirective, NumbersOnly, FormatJsonPipe, FileTypePipe] //AutofocusDirective,AccessRight2Directive
})
export class AppCommonModule {

}
